import JCard from './JCard';

export default JCard;
